import BotInterface from "./BotInterface";
export default function Patient() {
  return <BotInterface botType="patient" />;
}
